<!-- Header -->
<div
  class="ui-only flex fixed justify-between items-center py-1.5 sm:py-2 px-2 sm:px-3 lg:px-6 w-full top-0 backdrop-blur-xl z-50 bg-white/90 border-b border-gray-100"
>
  <a href="/dashboard/calculations" class="cursor-pointer flex-shrink-0">
    <app-logo></app-logo>
  </a>

  <!-- Page Title -->
  <div
    class="flex-shrink-0 bg-[#043B22]/10 px-3 py-1.5 rounded-lg border border-[#043B22]/20"
  >
    <div class="text-[10px] text-[#616161] tracking-wide">
      {{ locale.common.calculation }}
    </div>
    <div
      class="text-[12px] sm:text-[13px] text-[#043B22] font-semibold max-w-[250px] sm:max-w-[2 00px]"
    >
      {{ companyDetailsRecord?.calculationName }}
    </div>
  </div>

  <!-- Actions -->
  <div class="flex gap-1.5 sm:gap-3 items-center">
    <div (click)="goBack($event)">
      <app-button text="{{ locale.common.button_close }}">
        <app-minimize></app-minimize>
      </app-button>
    </div>
  </div>
</div>

<!-- Main Content with top padding for header -->
<div
  class="preview-report p-3 sm:p-5 lg:p-6 gap-3 pdf-page mt-12 sm:mt-14"
  id="pdfContent"
>
  <div class="flex flex-col justify-center items-center mb-2 sm:mb-3 mt-3">
    <img
      class="w-[140px] sm:w-[180px] h-auto mb-1.5"
      [src]="currentLogo"
      alt="Company Logo"
    />
    <p class="text-xs sm:text-sm text-center font-medium">
      {{ companyDetails?.companyName }}
    </p>
    <p class="text-[12px] text-center text-[#616161]">
      {{ formattedCompanyAddress }}
    </p>
  </div>

  <div
    class="index-wrapper border border-[#dcd9d9] rounded-lg sm:rounded-xl p-2.5 sm:p-4"
  >
    <h2 class="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-[#043B22]">
      # {{ locale.report.index }}
    </h2>

    <div class="flex flex-col sm:flex-row w-full gap-3 sm:gap-0">
      <div class="w-full sm:w-1/2 px-1.5 sm:px-3 text-left">
        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          1. {{ locale.report.methodological_approach }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          2. {{ locale.report.introduction }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          3. {{ locale.report.company_profile }}
        </h3>
        <ul class="text-xs sm:text-sm text-gray-600 mb-2 px-3">
          <li>3.1. {{ locale.report.mission }}</li>
          <li>3.2. {{ locale.report.vision }}</li>
        </ul>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          4. {{ locale.report.purpose_scope }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          5. {{ locale.report.regulatory_references }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          6. {{ locale.report.ghg_boundaries }}
        </h3>

        <ul class="text-xs sm:text-sm text-gray-600 mb-2 px-3">
          <li>6.1. {{ locale.report.organizational_boundaries }}</li>
          <li>6.2. {{ locale.report.reporting_boundaries }}</li>
          <li>6.3. {{ locale.report.categorization }}</li>
          <li>6.4. {{ locale.report.principles_adopted }}</li>
          <li>6.5. {{ locale.report.reporting_phases }}</li>
          <li>6.6. {{ locale.report.significance_definition }}</li>
        </ul>
      </div>

      <div class="w-full sm:w-1/2 px-1.5 sm:px-3 text-left">
        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          7. {{ locale.report.ghg_quantification }}
        </h3>
        <ul class="text-xs sm:text-sm text-gray-600 mb-2 px-3">
          <li>7.1. {{ locale.report.quantification_approach }}</li>
          <li>7.2. {{ locale.report.topics_reported }}</li>
          <li>7.3. {{ locale.report.category_1 }}</li>
          <li>7.4. {{ locale.report.category_2 }}</li>
          <li>7.5. {{ locale.report.category_3 }}</li>
          <li>7.6. {{ locale.report.category_4 }}</li>
          <li>7.7. {{ locale.report.category_5 }}</li>
          <li>7.8. {{ locale.report.category_6 }}</li>
          <li>7.9. {{ locale.report.total_emissions }}</li>
        </ul>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          8. {{ locale.report.results_comment }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          9. {{ locale.report.uncertainty_evaluation }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          10. {{ locale.report.uncertainty_evaluation }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          11. {{ locale.report.quality_management }}
        </h3>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          12. {{ locale.report.verification_role }}
        </h3>
        <ul class="text-xs sm:text-sm text-gray-600 mb-2 px-3">
          <li>12.1. {{ locale.report.reduction_activities }}</li>
          <li>12.2. {{ locale.report.carbon_offsetting }}</li>
        </ul>

        <h3
          class="relative font-semibold text-sm sm:text-base mb-2 after:content-[''] after:block after:w-1/2 after:h-[1px] after:bg-[#dcd9d9] after:ml-4"
        >
          13. {{ locale.report.glossary }}
        </h3>
      </div>
    </div>
  </div>

  <div
    *ngFor="let section of sections"
    class="shadow-sm p-2.5 sm:p-3 rounded-lg sm:rounded-xl report-section border border-[#dcd9d9]/50"
  >
    <div class="flex justify-between items-center mt-2">
      <h2 class="text-sm sm:text-base font-semibold text-[#043B22]">
        {{ section.title }}
      </h2>

      <button
        *ngIf="!section.isEditing && section.id !== 7"
        class="bg-[#043B22] rounded-md p-1 sm:p-1.5 cursor-pointer hover:bg-[#043B22]/90 transition-colors"
        (click)="editSection(section)"
      >
        <img
          src="/images/page-edit.svg"
          alt=""
          class="w-3.5 h-3.5 sm:w-4 sm:h-4"
        />
      </button>
    </div>

    <div
      *ngIf="!section.isEditing"
      class="p-2 text-xs sm:text-sm"
      [innerHTML]="getSafeHtml(section.content)"
    ></div>

    <div *ngIf="section.isEditing" class="px-2 sm:px-4 py-2 sm:py-3">
      <ckeditor
        [editor]="Editor"
        [(ngModel)]="section.content"
        [config]="editorConfig"
        (ready)="onReady($event)"
      >
      </ckeditor>

      <div class="flex flex-wrap gap-2 mt-2 sm:mt-3">
        <button
          class="bg-[#043B22] text-white px-2.5 sm:px-3 py-1 sm:py-1.5 rounded text-xs sm:text-sm hover:bg-[#043B22]/90 transition-colors cursor-pointer"
          (click)="saveSection(section)"
        >
          {{ locale.report.save }}
        </button>

        <button
          class="bg-gray-400 text-white px-2.5 sm:px-3 py-1 sm:py-1.5 rounded text-xs sm:text-sm hover:bg-gray-500 transition-colors cursor-pointer"
          (click)="cancelEdit(section)"
        >
          {{ locale.report.cancel }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Sticky Bottom Action Bar -->
<div
  class="ui-only fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] z-50 px-4 py-2"
>
  <div
    class="max-w-4xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4"
  >
    <button
      class="w-full sm:w-auto cursor-pointer flex items-center justify-center gap-2 bg-white text-[#043B22] border-2 border-[#043B22] text-[11px] sm:text-xs font-semibold rounded-lg px-5 sm:px-6 py-2.5 hover:bg-[#043B22]/5 transition-all"
      (click)="goBack($event)"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        ></path>
      </svg>
      {{ locale.report.back }}
    </button>
    <button
      class="w-full sm:w-auto cursor-pointer flex items-center justify-center gap-2 bg-gradient-to-r from-[#043B22] to-[#065a35] text-white text-[11px] sm:text-xs font-semibold rounded-lg px-5 sm:px-6 py-2.5 hover:from-[#065a35] hover:to-[#043B22] transition-all shadow-md shadow-[#043B22]/20"
      (click)="preview($event)"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        ></path>
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        ></path>
      </svg>
      {{ locale.report.preview_report }}
    </button>
    <!-- <button
      class="w-full sm:w-auto cursor-pointer flex items-center justify-center gap-2 bg-gradient-to-r from-[#043B22] to-[#065a35] text-white text-[11px] sm:text-xs font-semibold rounded-lg px-5 sm:px-6 py-2.5 hover:from-[#065a35] hover:to-[#043B22] transition-all shadow-md shadow-[#043B22]/20"
      (click)="download($event)">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
      </svg>
      {{ locale.report.download }}
    </button> -->
  </div>
</div>

<!-- Bottom spacing for sticky bar -->
<div class="ui-only h-20 sm:h-24"></div>

<!-- Preview Modal -->
<div
  *ngIf="showPreviewModal"
  class="fixed inset-0 z-[100] flex items-center justify-center"
>
  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-black/60 backdrop-blur-sm"
    (click)="closePreviewModal()"
  ></div>

  <!-- Modal Content -->
  <div
    class="relative bg-white rounded-xl shadow-2xl w-[95vw] h-[90vh] max-w-5xl flex flex-col overflow-hidden"
  >
    <!-- Modal Header -->
    <div
      class="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gradient-to-r from-[#043B22] to-[#065a35]"
    >
      <div class="flex items-center gap-3">
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          ></path>
        </svg>
        <h3 class="text-sm sm:text-base font-semibold text-white">
          {{ locale.report.preview_report }}
        </h3>
      </div>
      <button
        (click)="closePreviewModal()"
        class="p-2 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
      >
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>

    <!-- Modal Body - Scrollable Preview -->
    <div class="flex-1 overflow-auto bg-gray-100 p-4 sm:p-6">
      <div
        id="previewModalContent"
        class="max-w-[210mm] mx-auto bg-white preview-modal-content"
      >
        <app-report-preview
          #previewComp
          [companyDetails]="companyDetails"
          [locale]="locale"
        >
        </app-report-preview>
      </div>
    </div>

    <!-- Modal Footer -->
    <div
      class="flex items-center justify-end gap-3 px-4 py-2 border-t border-gray-200 bg-gray-50"
    >
      <button
        (click)="closePreviewModal()"
        class="px-4 py-2 text-xs sm:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
      >
        {{ locale.report.cancel }}
      </button>
      <!-- <button (click)="previewFromPreview()"
        class="px-4 py-2 text-xs sm:text-sm font-medium text-[#043B22] bg-white border border-[#043B22] rounded-lg hover:bg-[#043B22]/10 transition-all cursor-pointer flex items-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z">
          </path>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
          </path>
        </svg>
        Preview PDF
      </button> -->
      <button
        (click)="downloadFromPreviewWithPdfShift()"
        class="px-4 py-2 text-xs sm:text-sm font-medium text-white bg-gradient-to-r from-[#043B22] to-[#065a35] rounded-lg hover:from-[#065a35] hover:to-[#043B22] transition-all cursor-pointer flex items-center gap-2"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
          ></path>
        </svg>
        {{ locale.report.download }}
      </button>
    </div>
  </div>
</div>

<!-- Validation Modal -->
<div
  *ngIf="showValidationModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
>
  <div
    class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden"
  >
    <!-- Header -->
    <div class="bg-[#043B22] px-6 py-4">
      <h2 class="text-lg font-bold text-white futura flex items-center gap-2">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          ></path>
        </svg>

        {{
          currentLanguage === "english"
            ? "Report incomplete"
            : "Report incompleto"
        }}
      </h2>
    </div>

    <!-- Body -->
    <div class="px-6 py-4">
      <p
        class="text-[13px] text-[#616161] mb-4"
        [innerHTML]="
          currentLanguage === 'english'
            ? 'Some sections of the report are not yet complete.<br />Please complete all required information before generating the report.'
            : 'Alcune sezioni del report non sono ancora complete.<br />Compila tutte le informazioni richieste prima di procedere con la generazione del report.'
        "
      ></p>

      <ul class="space-y-2">
        <li
          *ngFor="let err of validationErrors"
          class="flex items-start gap-2 text-[13px] text-[#212121]"
        >
          <span class="text-[#dc2626] mt-0.5">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </span>
          {{ err }}
        </li>
      </ul>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-gray-50 flex justify-end">
      <button
        class="px-5 py-2 rounded-lg bg-[#043B22] hover:bg-[#043B22]/90 text-white text-[13px] font-medium transition-colors cursor-pointer"
        (click)="showValidationModal = false"
      >
        {{ currentLanguage === "english" ? "Close" : "Chiudi" }}
      </button>
    </div>
  </div>
</div>
